import request from "@/api/axios.setting";
import { removeToken } from "@/utils/role";
export function login(data) {
  return request({
    url: "/web/login",
    method: "post",
    data,
  });
}

export function register(data) {
  return request({
    url: "/web/register",
    method: "post",
    data,
  });
}

export function getUserInfo() {
  return request({
    url: "/user/getinfo",
    method: "get",
  });
}

export function refreshToken() {
  return request({
    url: "/user/newtoken",
    method: "post",
  });
}

export function upUserPwd(data) {
  return request({
    url: "/user/upUserPwd",
    method: "POST",
    data,
  });
}

export function upUserminiapp(data) {
  return request({
    url: "/user/upUserMiniapp",
    method: "POST",
    data,
  });
}

export function upUserWebSite(data) {
  return request({
    url: "/user/upUserWebSite",
    method: "POST",
    data,
  });
}

export function upUserQQ(data) {
  return request({
    url: "/user/upUserQQ",
    method: "POST",
    data,
  });
}

export function refreshWebToken() {
  return request({
    url: "/user/refreshWebToken",
    method: "POST",
  });
}

export function upUserMail(data) {
  return request({
    url: "/user/upUserMail",
    method: "POST",
    data,
  });
}

export function logout() {
  removeToken();
  return request({
    url: "/user/logout",
    method: "post",
  });
}

export function getHistory(params) {
  return request({
    url: "/user/history",
    method: "get",
    params,
  });
}

export function submitQuestion(data) {
  return request({
    url: "/user/insertQuestion",
    method: "POST",
    data,
  });
}

export function uploadFile(data) {
  return request({
    url: "/user/upload",
    method: "POST",
    data,
  });
}

export function uploadSubmit(data) {
  return request({
    url: "/user/uploadSubmit",
    method: "POST",
    data,
  });
}

export function uploadWeb(data) {
  return request({
    url: "/user/uploadWeb",
    method: "POST",
    data,
  });
}

export function getUploadList(params) {
  return request({
    url: "/user/uploadList",
    method: "get",
    params,
  });
}

export function feedback(data) {
  return request({
    url: "/user/feedback",
    method: "POST",
    data,
  });
}
export function getFeedList(params) {
  return request({
    url: "/user/feedbacklist",
    method: "get",
    params,
  });
}

export function getDashPart() {
  return request({
    url: "/user/dash",
    method: "get",
  });
}
export function getClicks() {
  return request({
    url: "/user/dashboard",
    method: "get",
  });
}
export function getDays(days) {
  return request({
    url: "/user/days/" + days,
    method: "get",
  });
}
